export default __webpack_public_path__ + "static/media/spec-3.df6aa4a1.png";